module.exports = __webpack_public_path__ + "static/img/industriales4.6a4da5b.png";